module Meevo.Plugins.ServiceCategories {
    "use strict";


    /**
    * Main Section of ServiceCategory 
    */
    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.ServiceCategory> {

        private subCatDisplayNameRegEx = new RegExp("^[a-zA-Z0-9]{1,40}$");
      /**
      * Base class override which defines what a DEFAULT model looks like.
      */
        createSectionModelInstance(postAdd: (data: any) => any): void {
            this.dataService.getTemplate(this.baseEndpoint).then((data) => {
                this.model = data;
            });
        }

        updateColor(isAdding: boolean): void {
            let color = this.model.backgroundColor;
            if(isAdding)
                this.model.subCategories[0].backgroundColor = color;
        }

    }

}